import React from "react";
import { motion } from "framer-motion";
import {
  Stethoscope,
  Scissors,
  Bone,
  BedDouble,
  Syringe,
  Activity,
  FlaskConical,
  Siren,
  Bath,
  ArrowRight,
} from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "../data/brand";

const ICONS = {
  Stethoscope,
  Scissors,
  Bone,
  BedDouble,
  Syringe,
  Activity,
  FlaskConical,
  Siren,
  Bath,
};

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative scroll-mt-24 py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="text-xs font-medium uppercase tracking-[0.2em] text-[#1E3A8A]">
              Nuestros servicios
            </span>
            <h2 className="mt-3 font-display text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Atención integral para cada etapa de tu mascota
            </h2>
          </div>
          <p className="max-w-md text-base leading-relaxed text-slate-600">
            Desde controles preventivos hasta cirugías complejas, contamos con
            el equipo y la tecnología para cuidar a tu compañero.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Stethoscope;
            const highlight = s.highlight;
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className={`group relative overflow-hidden rounded-2xl border p-6 transition-all duration-300 hover:-translate-y-1 ${
                  highlight
                    ? "border-[#EA580C]/30 bg-gradient-to-br from-[#EA580C] to-[#c2410c] text-white shadow-lg shadow-orange-500/20"
                    : "border-slate-200 bg-white hover:border-slate-300 hover:shadow-lg"
                }`}
              >
                <div
                  className={`inline-flex h-12 w-12 items-center justify-center rounded-xl ${
                    highlight
                      ? "bg-white/15 text-white"
                      : "bg-[#1E3A8A]/8 text-[#1E3A8A] group-hover:bg-[#1E3A8A] group-hover:text-white"
                  } transition-colors duration-300`}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <h3
                  className={`mt-5 font-display text-xl font-medium tracking-tight ${
                    highlight ? "text-white" : "text-slate-900"
                  }`}
                >
                  {s.title}
                </h3>
                <p
                  className={`mt-2 text-sm leading-relaxed ${
                    highlight ? "text-white/85" : "text-slate-600"
                  }`}
                >
                  {s.desc}
                </p>

                {highlight && (
                  <Link
                    to="/reserva"
                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-white/95 hover:text-white"
                  >
                    Llamar a urgencia <ArrowRight className="h-4 w-4" />
                  </Link>
                )}

                <div
                  className={`pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full ${
                    highlight ? "bg-white/10" : "bg-[#1E3A8A]/5"
                  } opacity-0 transition-opacity group-hover:opacity-100`}
                />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
